import { Component } from '@angular/core';
import {Router} from "@angular/router";
import { trigger, transition, style, animate } from '@angular/animations';
import { PlanService } from '../../services/plan/plan.service';
import { MealCategoryModel } from '../../models/home/meal-category-model';
import { Notify } from 'notiflix/build/notiflix-notify-aio';


@Component({
  selector: 'app-order-flow',
  templateUrl: './order-flow.component.html',
  styleUrls: ['./order-flow.component.scss'],
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ])
    ])
  ]
})
export class OrderFlowComponent {

  

  activeTab: number;
  preSelectedAllergies: any[] = [];
  mealCategories: MealCategoryModel[] = [];
  
  tabs = [
    { id: 1, label: 'Goal' },
    { id: 2, label: 'Meals' },
    { id: 3, label: 'Days' },
    { id: 4, label: 'Allergies' }
  ];

  mealsPerDay = [
    { value: 1, selected: false },
    { value: 2, selected: false },
    { value: 3, selected: false },
    { value: 4, selected: false }
  ];
  
  daysPerWeek = [
    { value: 3, selected: false },
    { value: 5, selected: false },
    { value: 6, selected: false },
    { value: 7, selected: false }
  ];


  allergyOptions = [
    { id: 'yes', label: 'Yes', selected: false },
    { id: 'no', label: 'No', selected: false }
  ];

  // this should be generated using the meal tags webservice
  goals = [
    { 
      id: 2, 
      label: 'Fat Loss', 
      description: '< 520 Calories <br> 40+ g Protein',
      icon: 'assets/images/weight-scale.svg',
      selected: false
    },
    { 
      id: 4, 
      label: 'General Health', 
      description: '550-600 Calories <br> 45+ g Protein',
      icon: 'assets/images/heart-add.svg',
      selected: false
    },
    { 
      id: 3, 
      label: 'Muscle Gain', 
      description: '700-800 Calories <br> 50+ g Protein',
      icon: 'assets/images/body-part-muscle.svg',
      selected: false
    }
  ];

  constructor(private router: Router, private planService: PlanService) { }

  ngOnInit(){

    this.activeTab = 1

    localStorage.removeItem('promo_code');
    localStorage.removeItem('promo_discount');
    localStorage.removeItem('free_shipping_type');
    localStorage.removeItem('selectedDate');
    localStorage.removeItem('promo_discount_id');

    // remove legacy orders
    localStorage.removeItem('planOrderDetails');

    // Forwards directly to Order Summary if Order Questions were already answered
    if (localStorage.getItem('cart')) {
      this.router.navigate(['/order-summary']);
    }

    this.planService.getMealCategories().subscribe((categories: any) => {
      this.mealCategories = categories;

      // Display Questions with already given answers
      if(localStorage.getItem('orderDetails')) {
        let orderDetails = JSON.parse(localStorage.getItem('orderDetails')!);
        let meal = this.mealsPerDay.find((x:any)=>x.value == orderDetails.mealPerDay);
        if(meal) meal.selected = true;
        let day = this.daysPerWeek.find((x:any)=>x.value == orderDetails.dayPerWeek);
        if(day) day.selected = true;
        let goal = this.goals.find((x:any)=>x.id == orderDetails.goal);
        if(goal) goal.selected = true;
        this.mealCategories.filter((x:any)=>orderDetails.categories?.includes(x.id)).forEach((x:any)=>x.selected = true);

        if(orderDetails.allergies && orderDetails.allergies.length > 0){
          this.allergyOptions.find( (x:any)=>x.id == 'yes' ? x.selected = true : x.selected = false);
        } else {
          this.allergyOptions.find( (x:any)=>x.id == 'no' ? x.selected = true : x.selected = false);
        }
        
        this.preSelectedAllergies = orderDetails.allergies;
        
      }

    });
    
  }

  selectMealCategory(category: any) {
    category.selected = !category.selected;
  }

  selectGoal(goal: any) {
    this.goals.forEach(g => g.selected = false);
    goal.selected = true;
  }

  selectMealsPerDay(meal: any) {
    this.mealsPerDay.forEach(m => m.selected = false);
    meal.selected = true;

    this.daysPerWeek.forEach(d => d.selected = false);
  }

  selectDaysPerWeek(day: any) {
    this.daysPerWeek.forEach(d => d.selected = false);
    day.selected = true;
  }

  selectAllergyOption(option: any) {
    this.allergyOptions.forEach(opt => opt.selected = false);
    option.selected = true;
  }

  get showAllergiesDialog(): boolean {
    return this.allergyOptions.find(o => o.selected)?.id === 'yes';
  }

  

  goToTab(tab: number) {
    if (tab <= 4 && this.didUserSelectOption(tab - 1)) {
      this.activeTab = tab;
    } else {
      this.handleErrorUnselectedOption();
    }
  }
  
  goToHome(){
    this.router.navigate(['/home']);
  }


  didUserSelectOption(tab: number) {
    if(tab == 0) {
      tab = 1;
    }
    switch (tab) {
      case 1: return this.goals.find((x: any) => x.selected);
      case 2: return this.mealCategories.find((x: any) => x.selected);
      case 3: return this.mealsPerDay.find((x: any) => x.selected) && this.daysPerWeek.find((x: any) => x.selected);
      case 4: return this.allergyOptions.find((x: any) => x.selected);
      default: return false;
    }
  }

  getSelectedMealsPerDay(){
    return this.mealsPerDay.find((x:any)=>x.selected)?.value;
  }

  addAllergiesAndGoToOrderSummary(allergies: any[]) {
    if(this.allergyOptions.find((x:any)=>x.selected)?.id == 'yes') {
      this.preSelectedAllergies = allergies.filter((x:any)=>x.selected).map((x:any)=>x.id);
    }     
    this.goToOrderSummary();
  }

  goToOrderSummary() {
    localStorage.setItem('orderDetails', JSON.stringify({
      type: 'Commit', // With the new Order Flow Nutrigenic implicitely sells only Commit Plans
      weeks: 8,
      mealPerDay: this.getSelectedMealsPerDay(),
      dayPerWeek: this.daysPerWeek.find((x:any)=>x.selected)?.value,
      goal: this.goals.find((x:any)=>x.selected)?.id,
      categories: this.mealCategories.filter((x:any)=>x.selected).map((x:any)=>x.id),
      allergies: this.allergyOptions.find((x:any)=>x.selected)?.id == 'yes' ? this.preSelectedAllergies : []
    }));

    this.router.navigate(["/order-summary"]);
  }


  handleErrorUnselectedOption(): void {
      let error = 'You must select an option before to continue';
      Notify.failure(error, {
          position: 'right-top',
          timeout: 3000
      });
  }
}